import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'CompanyAdminStatus',
})
export class CompanyAdminStatusPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform ( value : string ) {
    const statusMap = {
      active     : this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.ACTIVE'),
      canceled   : this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.CANCELED'),
      expired    : this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.EXPIRED'),
      past_due   : this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.PAST_DUE'),
      trialing   : this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.TRIALING'),
      trial_ended: this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.TRIAL_ENDED')
    };

    return statusMap[value] || this.translateService.instant('DASHBOARD_SPACE.ADMIN_DASHBOARD.STATUS.SUGGESTED');
  }
}